import React, { Fragment } from 'react';
import { cond, where, equals, always } from 'ramda';
import { string } from 'prop-types';
import { Route } from 'react-router-dom';
import styled from 'styled-components';
import { Strong } from '../Text';
import { Compare, Precision } from '../../constants';
import { isPresent } from '../../utils/helpers';
import {
  monthRangeFormat,
  timeIntervalPrecisionFormat,
  yearRangeFormat,
} from '../../utils/format';
import { Compare as ICompare, Precision as IPrecision } from '../../models';

const sup = styled.span`
  font-size: 8px;
  color: gray;
`;

const compareIntervals = (pathname, search) => {
  const isCompareChart =
    pathname.match(/\/chart/) && search.match(/compChartType=comparisonChart/);
  const isCompareTable =
    pathname.match(/\/table/) &&
    (search.match(/compare=year/) ||
      search.match(/compare=custom/) ||
      search.match(/compare=period/));
  return isCompareChart || isCompareTable;
};

// Is this really better than separate components?
export const TimeRange = cond([
  // Line chart
  [
    where({ compare: equals(Compare.NONE), timespanInterval: isPresent }),
    ({ timespanInterval, precision }) => (
      <Strong>
        {timeIntervalPrecisionFormat[precision](timespanInterval)}
      </Strong>
    ),
  ],

  // Recurring with single year
  [
    where({
      compare: equals(Compare.RECURRING),
      compareInterval: isPresent,
      precision: equals(Precision.YEARLY),
    }),
    ({ compareInterval }) => <Fragment>{'recurring year '}</Fragment>,
  ],

  // Recurring with intervals
  [
    where({
      compare: equals(Compare.RECURRING),
      compareInterval: isPresent,
      timespanInterval: isPresent,
      precision: equals(Precision.MONTHLY),
    }),
    ({ timespanInterval, compareInterval }) => (
      <Fragment>
        <Strong>{monthRangeFormat(timespanInterval)}</Strong>
        {' compared to '} <strong>{yearRangeFormat(compareInterval)}</strong>
      </Fragment>
    ),
  ],

  // Comparison
  [
    where({
      compare: isPresent,
      timespanInterval: isPresent,
      compareInterval: isPresent,
    }),
    ({ timespanInterval, compareInterval, precision }) => (
      <Fragment>
        <Strong>
          {timeIntervalPrecisionFormat[precision](timespanInterval)}
        </Strong>
        <Route
          render={({ location: { pathname, search } }) => (
            <sup>{compareIntervals(pathname, search) ? 'TI 2' : ''}</sup>
          )}
        />
        {' compared to '}
        <Strong>
          {timeIntervalPrecisionFormat[precision](compareInterval)}
        </Strong>
        <Route
          render={({ location: { pathname, search } }) => (
            <sup>{compareIntervals(pathname, search) ? 'TI 1' : ''}</sup>
          )}
        />
      </Fragment>
    ),
  ],

  [always(true), always(null)],
]);

TimeRange.propTypes = {
  compare: ICompare.isRequired,
  precision: IPrecision.isRequired,
  compareInterval: string,
  timespanInterval: string,
};

export default TimeRange;



// WEBPACK FOOTER //
// ./src/components/CrimeCount/TimeRange.jsx